import { Card, CardContent } from "../../../card";
import { Check, CheckCircle2 } from "lucide-react";

interface FeatureListProps {
  data: {
    title?: string;
    items: Array<{
      text: string;
      description?: string;
      highlight?: boolean;
    }>;
    columns?: 1 | 2;
  };
}

export const FeatureList = ({ data }: FeatureListProps) => {
  if (!data?.items || !Array.isArray(data.items)) return null;

  const cols = data.columns === 2 ? "md:grid-cols-2" : "grid-cols-1";

  return (
    <Card className="my-8">
      <CardContent className="p-6">
        {data.title && (
          <h3 className="text-lg font-semibold text-neutral-900 mb-6">{data.title}</h3>
        )}

        <div className={`grid ${cols} gap-4`}>
          {data.items.map((item, idx) => (
            <div
              key={idx}
              className={`flex gap-3 p-3 rounded-lg transition-all duration-200 ${
                item.highlight
                  ? 'bg-gradient-to-r from-orange-50 to-orange-50/50 border border-orange-200 hover:border-orange-300 hover:shadow-[0_2px_12px_rgba(255,107,53,0.1)]'
                  : 'hover:bg-neutral-50 border border-transparent hover:border-neutral-200'
              }`}
            >
              <div className="flex-shrink-0 mt-0.5">
                {item.highlight ? (
                  <CheckCircle2 className="w-5 h-5 text-orange-500" />
                ) : (
                  <Check className="w-5 h-5 text-orange-400" />
                )}
              </div>
              <div>
                <div className={`font-medium ${item.highlight ? 'text-orange-900' : 'text-neutral-900'}`}>
                  {item.text}
                </div>
                {item.description && (
                  <div className={`text-sm mt-1 ${item.highlight ? 'text-orange-700' : 'text-neutral-500'}`}>
                    {item.description}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
